export default "__VITE_ASSET__BIJt7b0d__"